module.exports = __webpack_public_path__ + "static/media/006.17bf353a.jpg";